export default function PrintActions({ onPrint, onReset, onDownloadPdf, hasErrors }) {
  return (
    <div className="print-actions">
      <button className="button button-secondary" type="button" onClick={onReset}>
        Reset invoice
      </button>

      <button
        className="button button-secondary"
        type="button"
        onClick={onDownloadPdf}
        // disabled={hasErrors}
      >
        Download Invoice as PDF
      </button>

      <button
        className="button button-primary"
        type="button"
        onClick={onPrint}
        aria-disabled={hasErrors}
      >
        Print invoice
      </button>
    </div>
  );
}